const NotificationTypes = {
    News: 'news',
    Article: 'article',
    Message: 'message',
} as const;

export default NotificationTypes;
